export const countryList = {
  title: "قائمة الدول",
  line1:
    "يرد أدناه سرد لمراحل GDHM الإجمالية لكل دولة مشاركة. وتحدد الدرجات القطرية للمؤشرات المرحلة الإجمالية للصحة الرقمية للبلد.",
  line2:
    "وللحصول على المزيد من التفاصيل التفصيلية لأي بلد، يرجى زيارة الصفحة الخاصة به.",
  exportButtonText: "تصدير بيانات جميع البلدان",
};
